import { render, staticRenderFns } from "./Pendings.vue?vue&type=template&id=5a328a99&scoped=true&"
import script from "./Pendings.vue?vue&type=script&lang=js&"
export * from "./Pendings.vue?vue&type=script&lang=js&"
import style0 from "./Pendings.vue?vue&type=style&index=0&id=5a328a99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a328a99",
  null
  
)

export default component.exports